<template>
  <div class="audit-type">
    <!-- 操作栏容器 -->
    <div class="audit-info-operation-container">
      <div class="notice-search">
        <search
          :placeholder="placeholder"
          v-model="checkName"
          @search="search"
        />
      </div>
      <div class="audit-info-button-container">
        <!-- 新增 -->
        <!-- <button class="button add-audit" @click="addFormShow = true">
          <i class="iconfont icon-addGlade"></i>新增类型
        </button> -->
        <!-- 批量删除 -->
        <!-- <button class="button delete-audit" @click="deleteClick">
          <i class="iconfont icon-delete" />批量删除
        </button> -->
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="audit-info-table-container" v-bitmap="checkListGetResult">
      <checkList class="audit-list" :checkList="checkList" v-show="total" />
    </div>
    <!-- 分页容器 -->
    <div class="audit-info-pagination-catainer">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
import checkList from "./components/check-list/checkList.vue";

export default {
  data() {
    return {
      placeholder: "请输入审核类型",
      addFormShow: false,
      checkName: "",
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      checkListGetResult: "nullData",
      checkList: null,
      total: 1,
    };
  },
  components: {
    search,
    checkList,
  },
  provide() {
    return {
      refresh: this.getSchoolCheckList,
    };
  },
  created() {
    this.getSchoolCheckList();
  },
  methods: {
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getSchoolCheckList();
    },
    deleteClick() {},
    search(e) {
      this.checkName = e;
      this.getSchoolCheckList();
    },
    getSchoolCheckList() {
      let data = {
        schoolId: this.user.schoolId,
        checkName: this.checkName,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      };
      // this.checkListGetResult = "loading";
      this.get(this.$url.getSchoolCheckList, data).then((res) => {
        // console.log("获取学校审核类型==>", res);
        if (res.code != 200) {
          this.checkListGetResult = "error";
          return this.$message.error("获取审核类型失败");
        }
        this.checkList = res.rows;
        this.total = res.total;
        this.total > 0
          ? (this.checkListGetResult = "success")
          : (this.checkListGetResult = "nullData");
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getSchoolCheckList();
    },
  },
};
</script>

<style lang='scss' scoped>
@import "./auditType.scss";
</style>